<template>
  <!-- :action="{
        target: upyunUpload,
        headers: {
          Authorization: auth
        },
        data: getParams,
        checkSuccess: checkSuccess
      }" -->
  <div class="upload-box2">
    <cube-upload
      ref="upload"
      :auto="false"
      :simultaneous-uploads="1"
      :accept="accept"
      @file-removed="delFile"
      @files-added="filesAdded"
    >
      <div class="cube-upload-file-box">
        <cube-upload-file
          v-for="(file, i) in fileList"
          :key="i"
          :file="file"
        >
          <i
            class="iconfont iconicon-test28"
            @click="delFile(file)"
          />
          <div
            v-if="file.file_type.indexOf('image/')=== -1"
            class="file-item"
          >
            <i class="iconfont iconicon-test22" />
          </div>
          <img
            v-else
            :src="file.file_url"
          > <p>{{ file.file_name }}</p>
        </cube-upload-file>
        <cube-upload-btn
          :multiple="false"
          :accept="accept"
        >
          <i>＋</i>
        </cube-upload-btn>
      </div>
    </cube-upload>
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>
<script>
import axios from 'axios'
import { upyunUpload } from '@/lib/config'
import { uploadSignature } from '@/services/index'
import store from '@/store'

export default {
  components: { },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    // console.log(upyunUpload)
    return {
      /* params: {
        policy: '',
        signature: ''
      }, */
      fileList: this.data.fieldvalue || null,
      upyunUpload
    }
  },
  computed: {
    auth () {
      return store.state.auth
    },
    accept () {
      return this.data.accept || '*'
      // return '*'
    }
  },
  created () {
    this.setDefault()
  },
  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    setDefault () {
      if (!this.fileList.length) return
      this.fileList = this.fileList.map(item => {
        item.uid = item.id || 'uid' + Math.random()
        item.name = item.file_name
        item.url = item.file_url
        item.description = item.name
        item.href = item.file_url
        item.title = this.$t('message["1304"]')
        return item
      })
    },
    async filesAdded (fileList) {
      let hasIgnore = false
      let msg = ''
      for (let file of fileList) {
        if (file.size > 1024 * 1024 * 20) { // 支持20M以内的文件上传
          file.ignore = true
          hasIgnore = true
          msg = this.$t('message["1267"]')
        }
        if (this.accept.indexOf('image') !== -1 && file.type && file.type.indexOf('image') === -1) {
          // if (file.type && file.type.indexOf('image') === -1) {
          file.ignore = true
          hasIgnore = true
          msg = this.$t('message["1599"]')
        }

        !file.ignore && this.uploadSignature(file).then(res => {
          this.uploadFile(file, res)
        })
      }

      hasIgnore && this.$createToast({
        type: 'warn',
        time: 1000,
        txt: msg
      }).show()
    },
    uploadSignature (file) {
      return new Promise(async (resolve, reject) => {
        const chain = await uploadSignature()
        chain.config({
          tip: false
        })
          .params({
            'filename': [file.name] // 文件本地路径
          })
          .onSuccess(async ([data = {}]) => {
            const {
              policy,
              signature,
              domain,
              // upyunurl,
              _upt
            } = data

            let params = {}
            params.file_url = domain + _upt
            params.policy = policy
            params.signature = signature
            // vm.action = upyunurl

            return resolve(params)
          })
          .fetch()
      })
    },
    async uploadFile (file, res) {
      let vm = this
      let formData = new FormData()
      formData.append('policy', res.policy)
      formData.append('signature', res.signature)
      formData.append('file', file)
      console.log(file)
      /* const chain = await uploadFile(upyunUpload)
      chain
        .config({
          tip: false
        })
        .params(formData)
        .onSuccess(res => {
          console.log(res)
          this.$bus.$emit('getPic', res)
        })
        .fetch() */
      axios.post(upyunUpload, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(function (response) {
          // console.log(response)
          let one = {
            file_name: file.name,
            file_url: res.file_url,
            file_size: response.data.file_size,
            file_type: response.data.mimetype
          }
          /* file_size: 83916
          image-frames: 1
          image-height: 900
          image-type: "JPEG"
          image-width: 680
          message: "ok"
          mimetype: "image/jpeg"
          sign: "b5a36f245b05529117023f39a858c6fc"
          time: 1572945987
          url: "/images/dfc0e75 */
          vm.fileList.push({ uid: 'uid' + Math.random(), ...one })
          vm.$emit('change', vm.fileList)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    delFile (file) {
      console.log(file)
      // let filepath = file.response.data.filepath
      let index = this.fileList.findIndex(item => item.uid === file.uid)
      this.fileList.splice(index, 1)
    },
    validateFile () {
      let { fieldtype = '', fieldvalue = {}, isneeded, message } = this.data

      this.data.messages.custom = ''

      if (fieldtype !== 'file' || !isneeded) {
        return true
      }
      if (fieldvalue.length) {
        return true
      } else {
        this.data.messages.custom = message || ''
        return false
      }
    },
    resetValidate () {
      this.$refs.formItem.reset()
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-box2 ::v-deep {
  /* .cube-upload-btn-def {
    background: url(~@/assets/images/upload-img.png) no-repeat;
  } */
  .cube-upload-btn {
     text-align: center;
    width: 70px;
    height: 70px;
    text-align: center;
    background: #fff;
    border-radius: 2px;
    border: 1px solid #ebebeb;
    line-height: 60px;
    margin-left: 10px;
    i{
      color: #666;
      font-style: normal;
    }
  }
  .cube-upload-file-box{
    display: flex;
    flex-flow: wrap;
    p{
      max-height: 36px;
      line-height: 18px;
      overflow: hidden;
      color: #666;
      word-break: break-all;
      width: 70px;
      font-size: 12px;
    }
  }
  .cube-upload-file{
    margin-left: 10px;
    position: relative;
    .iconicon-test28{
      position: absolute;
      right: -8px;
      width: 20px;
      height: 20px;
      top: -8px;
      color: #fff;
      background: rgba(0,0,0,0.8);
      border-radius: 50%;
      text-align: center;
      line-height: 20px;

    }
    img, .file-item{
      width: 70px;
      height: 70px;
      border-radius: 2px;
      border: 1px solid #ebebeb;
      background: #fff;
      text-align: center;
      line-height: 70px;
    }
  }
}
</style>
